<template>
  <div data-aos="fade-up" class="row">

    

    <div class="col-lg-12" id="post-head">
     <div class="container post-top">
       <div class="col-lg-12 d-flex post-date">
         <img src="/static/images/icons/calendar.svg"/>
         <h4>{{today}}</h4>
         <p>Actualizado</p>
       </div>
      <div class="bg-light text-center banner-2 mt-3"  v-if="isMobile()">
          PUBLICIDAD
      </div>
      <h1 class="titulo-categoria">{{categoria}}</h1>
     </div>
    </div>

    <div class="col-lg-12" id="post-top">
        <div class="container">   
           <div class="row post">
             <div class="col-lg-8">
               <h1>{{titulo}}</h1>
               <h2>{{introduccion}}</h2>
               <img :src="url + imagen"/>
             </div>
             <div class="col-lg-4" v-if="!isMobile()">
               <div class="bg-light text-center banner-2" style="height:100%">
                 PUBLICIDAD
                </div>
             </div>
           </div>
        </div>
    </div>
    
    <div class="col-lg-12" id="post-body"> 
      <div class="container pt-0">
        <div class="row post" >
          <div class="col-lg-8">
            <div class="row">
              <div class="col-lg-12">
              <h4>Publicado - {{fecha}}</h4>
              </div>   
            <div class="col-lg-12 mb-4" style="margin-top:-49px" v-if="!isMobile()">
            <div class="col-lg-4 float-right space-between"> 
              <div class="row">
                <div class="col-lg-4 ">
                  <a href="" class="dropbtnC"><img src="/static/images/icons/message.svg" /></a>
                </div>
                <div class=" col-lg-4">
                  <a href="" class="dropbtnC"><img src="/static/images/icons/heart.svg"/></a>
                </div>
                <div class=" col-lg-4">        
                  <div class="dropdown" id="dropdown">    
                    <a  class="dropbtn" id="btnShare"><img src="/static/images/icons/share.svg"/></a>
                    <div class="dropdown-content row" id="dropcontent">
                      <a :href="shareFB+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/fb.png"/></a>
                      <a :href="shareTW+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/tw.png"/></a>
                      <a :href="shareIN+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/in.png"/></a>
                      <a :href="shareWA+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/wa.png"/></a>
                      <a :href="shareMail" class="col-sm-12 btnSocial"><img src="/static/images/icons/ma.png"/></a>
                      <a  class="col-sm-12 btnSocial" @click="copyUrl()"><img src="/static/images/icons/link.png"/></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div class="col-12 mb-3" v-else>
            <div class="col-8 float-right "> 
              <div class="row">
                <div class="col-4">
                  <a  class="dropbtnC"><img src="/static/images/icons/message.svg" /></a>
                </div>
                <div class="col-4">
                  <a  class="dropbtnC"><img src="/static/images/icons/heart.svg"/></a>
                </div>
                <div class="col-4 ">        
                  <div class="dropdown" id="dropdown">    
                    <a  class="dropbtn" id="btnShare"><img src="/static/images/icons/share.svg"/></a>
                    <div class="dropdown-content row" id="dropcontent"> 
                      <a :href="shareFB+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/fb.png"/></a>
                      <a :href="shareTW+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/tw.png"/></a>
                      <a :href="shareIN+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/in.png"/></a>
                      <a :href="shareWA+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/wa.png"/></a>
                      <a :href="shareMail" class="col-sm-12 btnSocial"><img src="/static/images/icons/ma.png"/></a>
                      <a  class="col-sm-12 btnSocial" @click="copyUrl()"><img src="/static/images/icons/link.png"/></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <p ref="Descripcion"></p>
            </div>
          </div>
          <div class="col-12 mb-3" v-if="isMobile()">
            <hr/>
            <div class="col-8 float-right "> 
              <div class="row">
                <div class="col-4">
                  <a  class="dropbtnC"><img src="/static/images/icons/message.svg" /></a>
                </div>
                <div class="col-4">
                  <a  class="dropbtnC"><img src="/static/images/icons/heart.svg"/></a>
                </div>
                <div class="col-4 ">        
                  <div class="dropdown" id="dropdown2">    
                    <a  class="dropbtn" id="btnShare2"><img src="/static/images/icons/share.svg"/></a>
                    <div class="dropdown-content row" id="dropcontent2"> 
                      <a :href="shareFB+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/fb.png"/></a>
                      <a :href="shareTW+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/tw.png"/></a>
                      <a :href="shareIN+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/in.png"/></a>
                      <a :href="shareWA+shereable_link" class="col-sm-12 btnSocial" target="_blank"><img src="/static/images/icons/wa.png"/></a>
                      <a :href="shareMail" class="col-sm-12 btnSocial"><img src="/static/images/icons/ma.png"/></a>
                      <a  class="col-sm-12 btnSocial" @click="copyUrl()"><img src="/static/images/icons/link.png"/></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <hr/>
          </div>
          <div class="col-lg-4">
            <ArticulosVert/>
          </div>
        </div>
      </div>  
    </div>

     <div class="col-lg-12" id="post-bottom">
      <div class="container">
        <div class="divider-01"/>
      </div>
    </div>
    
    <div class="col-lg-12" id="post-bottom">
      <div class="container" v-if="!isMobile()">
        <h3 >MÁS INFORMACIÓN</h3>
        
        <Articulos />
      </div>
      <div class="container mb-4" v-else>
        <h1 class="titulo_precio">Solicita tu demostración</h1>
        <b-button to="/about" pill size="sm" class="my-2 my-sm-0 btnDemo" type="submit">Solicitar demo</b-button>
      </div> 
    </div>

    <input id="urlClipboard" :value="shereable_link" hidden="hidden"/>
  </div>
</template>

<script>
import env from '@/plugins/enviroment';
import Articulos from '@/components/articulos-post.vue'
import ArticulosVert from '@/components/articulos-vert.vue'
import postsApi from "../api/posts";
import { mapActions, mapState } from "vuex";
import Notify from "@/plugins/notify";

export default {
  name: 'Post',
  components: {
    Articulos,
    ArticulosVert
  },
  data() {
    return {
      today:"",
      categoria:"",
      titulo:"",
      introduccion:"",
      //descripcion:"",
      imagen:"",
      fecha:"",
      url:"",
      shereable_link:"",
      shareFB:"",
      shareTW:"",
      shareWA:"",
      shareIN:"",
      shareMail:""
    }
  },
  metaInfo () {
    return {
      title:this.titulo,
      meta: [
              {name: 'description', content: this.introduccion},
              {property: 'og:title', content: this.titulo},
              {property: 'og:description', content: this.introduccion},
              {property: 'og:locale', content:"es_ES"},
              {property: 'og:type', content:"article"},
              {property: 'og:site_name', content: env.publicURL},
              {property: 'og:image', content: this.url + this.imagen},//image:height y :width para darle tamaño en la publicacion
              {property: 'og:url', content: this.shereable_link},
              {property: 'twitter:card', content:"summary_large_image"},
              {property: 'twitter:title', content: this.titulo},
            ]
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapState("posts",["categoria_id"]),
    ...mapState("menu",["principal"]),
    name() {
      return this.data 
    }
  },
  watch: {
    $route(to, from) {
      //console.log(to.params)
      this.getPost(to.params.id);
      this.getToday();
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  },
  methods: {
    ...mapActions("posts",["setPostsByCategory"]),
    ...mapActions("menu",["setMenu"]),
    copyUrl(){
      
      var copyText = document.getElementById("urlClipboard");
      copyText.removeAttribute("hidden");

      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");

      copyText.setAttribute("hidden","hidden");

      /* Alert the copied text */
      Notify.SuccessToast("LINK copiado en el portapapeles");
    },
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    getPost(id){
      postsApi
      .getPost(id)
      .then(response => {

        this.categoria = response.categoria.nombre;
        this.setPostsByCategory(response.categoria.id);
        this.titulo = response.titulo;
        this.introduccion = response.introduccion;
        this.imagen = response.imagen;
        this.fecha = this.convertDate(response.fecha_publicacion);
        this.$refs.Descripcion.innerHTML = response.descripcion;

        this.shareMail = "mailto:?subject=Leer: "+this.titulo+"&body="+this.titulo+"%0D%0A%0D%0A"+this.introduccion+"%0D%0A%0D%0A Ver Post Completo en: "+this.shereable_link;
        //console.log(response);
      }).catch(err => {
        console.log("error post");
        this.$router.push({name:"NotFound"}); 
      });
    },
    convertDate(param){
      param = param.split('-');
      let meses = new Array("ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC");
      let f = new Date(param[0], param[1] - 1 , param[2] );

      let date = f.getDate() +" "+ meses[f.getMonth()] +" "+ f.getFullYear();

      return date;
    },
    dropShare(){ 
      let btnShare = document.getElementById('btnShare');
      let dropdown = document.getElementById('dropdown');
      let dropcontent = document.getElementById('dropcontent');

      btnShare.addEventListener('mouseenter', function(e) {
        dropdown.classList.add("dropdown-hover");
        dropcontent.classList.add("dropdown-content-hover");
      });
      dropdown.addEventListener('mouseleave', function(e) {
        dropdown.classList.remove("dropdown-hover");
        dropcontent.classList.remove("dropdown-content-hover");
      });
      if(this.isMobile()){
        let btnShare2 = document.getElementById('btnShare2');
        let dropdown2 = document.getElementById('dropdown2');
        let dropcontent2 = document.getElementById('dropcontent2');

        btnShare2.addEventListener('mouseenter', function(e) {
          dropdown2.classList.add("dropdown-hover");
          dropcontent2.classList.add("dropdown-content-hover");
        });
        dropdown2.addEventListener('mouseleave', function(e) {
          dropdown2.classList.remove("dropdown-hover");
          dropcontent2.classList.remove("dropdown-content-hover");
        });
      }
      
    },
    getToday(){
      let meses = new Array("ENE","FEB","MAR","ABR","MAY","JUN","JUL","AGO","SEP","OCT","NOV","DIC");
      let f=new Date();

      this.today = f.getDate() +" "+ meses[f.getMonth()] +" "+ f.getFullYear();
    },
    init(){
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      
      this.getPost(this.$route.params.id);
      this.setMenu(false);
      this.url = env.baseURL;
      this.shareFB = env.shareFB;
      this.shareTW = env.shareTW;
      this.shareWA = env.shareWA;
      this.shareIN = env.shareIN;
      this.shereable_link = env.publicURL + this.$route.path;
    }

  },
  mounted () {
    this.init();
    this.getToday();
    this.dropShare();
  },created () {
    
  }
}
</script>

<style scoped>

.banner-1{
    padding:33px;
  }
  .banner-2{
    padding:50px;
  }
  
  .bg-post-add{
    background:url("/static/images/post_add.png");
  }

  /* boton subir
  */
  #myBtn {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: red;
    color: white;
    cursor: pointer;
    padding: 15px;
    border-radius: 4px;
  }

  #myBtn:hover {
    background-color: #555;
  }

  .dropdown {
    position: absolute;
    z-index: 1;
    width: 70px;
    display: block;
    border-radius:100px;
    transition:0.2s;
  }

  .dropdown-hover{
    margin:-30px -10px 0px -10px;
    padding:30px 10px 0px 10px; 
    background-color: #ffffff;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  }
  .dropbtn {
    margin-bottom:25px;
    width: 50px;
    display: block;
  }
  
  .dropbtnC {
    margin-bottom:16px;
    width: 50px;
    margin-left: auto;
    display: block;
  }

  .dropdown-content a {
    text-align: center;
    text-decoration: none;
    visibility: hidden;
    transition:box-shadow 0.3s, visibility 0s;
  }

  .dropdown-content-hover a{
    visibility: visible;
  }

  .dropdown-content a:hover {
   box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  }

  .btnSocial{
    background-color: #2DB9D1;
    opacity: 0.5;
    border-radius: 150px;
    padding: 5px;
    margin-bottom: 10px;
  }


  /**
  * DIVIDERS
  */
  .divider-01 {
    height: 5px;
    width: 30%;
    background-color: #E8404E;
    border-radius: 3px;
    margin-right: auto;
  }

  .post-date h4{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 15px;

    margin:auto 0 auto 5px;
    color: #828282;  
  }

  .post-date p{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    margin:auto 0 auto 25px;
    color: #BDBDBD;
  }

  h3{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140.62%;
    color: #1E2245;
    text-align: left;
    padding-top:40px;
    padding-bottom: 40px;
  }

  .titulo-categoria{
    font-family: Muli;
    font-style: normal;
    font-weight: 800;
    font-size: 50px;
    line-height: 70px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #2DB9D1;
    margin-top:50px;
    margin-bottom:60px;
  }

  .post{
    text-align: left;
  }

  .post h1{
    font-family: Muli;
    font-style: normal;
    font-weight: 800;
    font-size: 45px;
    line-height: 55px;
    letter-spacing: 0.2px;
    color: #1E2245;
    margin-bottom: 20px;
  }
  
  .post h2{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 35px;
    letter-spacing: 0.2px;
    color: #1E2245;
    margin-bottom: 40px;
  }

  .post img{
    width: 100%;
    height: auto;
    border-radius: 10px;
  }

  .post h4{
    margin:15px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 23.1636px;
    line-height: 29px;
    color: #828282;
  }

  .post p{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 30px;
    letter-spacing: 0.274443px;
    color: #1E2245;
  }
  
 
  @media(max-width: 768px){
  .dropdown {
    width: 50px;
  }
  .dropdown-hover{
    margin:-20px -7px -0px -7px;
    padding:20px 7px 0px 7px; 
  }
  .dropbtn {
    width: 30px;
    margin-bottom: 10px;
  }
  
  .dropbtnC {
    width: 30px;
  }

  .btnSocial{
    padding: 1px;
    margin-bottom: 7px;
  }


    .post-top{
      margin-top:-10%;
    }

    .post-date h4{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;

    margin:auto 0 auto 5px;
    color: #828282;  
  }

  .post-date p{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    margin:auto 0 auto 25px;
    color: #BDBDBD;
  }


     .divider-01 {
    height: 5px;
    width: 100%;
    background-color: #E8404E;
    border-radius: 3px;
    margin-right: auto;
    margin-left: auto;
  }

  h3{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140.62%;
    color: #1E2245;
    text-align: left;
    padding-top:40px;
    padding-bottom: 40px;
  }



  .titulo-categoria{
    font-family: Muli;
    font-style: normal;
    font-weight: 800;
    font-size: 40px;
    line-height: 70px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #2DB9D1;
    margin-top:20px;
    margin-bottom:0px;
  }
  .post{
    margin-top:-50px;
  }

  .post h1{
    font-family: Muli;
    font-style: normal;
    font-weight: 800;
    font-size: 21px;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: #1E2245;
    
  }
  
  .post h2{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: #1E2245;
    padding-bottom:10px;
  }

  .post img{
    width: 100%;
    height: auto;
    border-radius: 10px;
  }

  .post h4{
    margin:15px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    color: #828282;
  }

  .post p{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 24px;
    letter-spacing: 0.2px;
    color: #1E2245;
  }

    .btnDemo {
    font-family: Muli-Bold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        color: #FFF ;
        background: #2DB9D1;
        border-color: #2DB9D1;
            width: 100%; 
            margin-bottom: 25px;
            padding-bottom: 13px;
            padding-top:13px;
            border-radius: 14px;
        }

         .titulo_precio {
        font-family: Muli;
        font-style: normal;
        font-weight: 800;
        font-size: 26px;
        line-height: 18px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2245;
        margin-bottom:30px;
        }
  }

 
  @media only screen and(max-width: 30%) {
    #demo {
      display: none;
    }
  }
</style>
